// extracted by mini-css-extract-plugin
export var buttonWrap = "buttonSelector-module--buttonWrap--4922c";
export var svg = "buttonSelector-module--svg--4d967";